<template>
  <div class="step-container w-100">
    <div v-if="data.components && data.components[currentComponent]" class="w-100">
      <div v-html="data.components[currentComponent].html" :style="data.components[currentComponent].style" />
    </div>

    <div v-if="data.subtitles && data.subtitles[currentSubtitle]" class="mt-4 w-100">
      <div v-if="data.subtitles[currentSubtitle].image" class="mb-4 p-2 text-center">
        <b-img :src="data.subtitles[currentSubtitle].image" height="200" />
      </div>

      <div class="rounded bg-lightblack mt-4 p-2 m-auto" style="width: 80%; min-height: 100px">
        <img src="@/assets/jeanluc.png" class="float-left user-photo float-left mr-4" width="75" />
        <p class="text-white" style="font-size: 21px" v-html="data.subtitles[currentSubtitle].text" />
      </div>
    </div>

    <div class="player-controllers rounded bg-lightblack p-2">
      <b-button variant="transparent" @click="goBack">
        <img src="@/assets/icons/player-previous.svg" width="10" height="10" />
      </b-button>

      <b-button v-if="!isPlaying" variant="transparent" @click="$refs['player-audio'].play()">
        <img src="@/assets/icons/player-play.svg" width="20" height="20" />
      </b-button>

      <b-button v-else variant="transparent" @click="$refs['player-audio'].pause()">
        <img src="@/assets/icons/player-pause.svg" width="20" height="20" />
      </b-button>

      <b-button variant="transparent" @click="goNext">
        <img src="@/assets/icons/player-next.svg" width="10" height="10" />
      </b-button>
    </div>

    <audio v-if="data.audio" :src="data.audio" @ended="$emit('ended')" ref="player-audio" preload></audio>
  </div>
</template>

<script>
import { BImg, BButton } from "bootstrap-vue";

export default {
  name: "AudioStep",
  components: { BImg, BButton },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      intervalId: null,
      currentTime: 0,
      currentComponent: -1,
      currentSubtitle: 0,
      duration: 0,
      isPlaying: false,
    };
  },
  mounted() {
    this.startInterval();
    this.$refs["player-audio"].play();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    currentTime() {
      this.updateCurrentSubtitle();
      this.updateCurrentComponent();
      this.checkIfAudioEnded();
    },
  },
  methods: {
    startInterval() {
      this.intervalId = setInterval(() => {
        if (this.$refs["player-audio"]) {
          this.isPlaying = !this.$refs["player-audio"].paused;
          this.duration = Math.floor(this.$refs["player-audio"].duration);
          this.currentTime = Math.floor(this.$refs["player-audio"].currentTime);
        }
      }, 500);
    },
    updateCurrentSubtitle() {
      const subtitles = this.data.subtitles || [];
      const subtitleIndex = subtitles.findIndex(({ startsTime }, i) => {
        const endTime = subtitles[i + 1] ? subtitles[i + 1].startsTime : this.duration;
        return startsTime <= this.currentTime && this.currentTime < endTime;
      });
      this.currentSubtitle = subtitleIndex;
    },
    updateCurrentComponent() {
      const components = this.data.components || [];
      const componentIndex = components.findIndex(({ startsTime, endsTime }) => {
        return startsTime <= this.currentTime && this.currentTime < endsTime;
      });
      this.currentComponent = componentIndex;
    },
    checkIfAudioEnded() {
      if (this.duration <= this.currentTime) {
        this.$emit("success");
      }
    },
    goBack() {
      this.updateAudioTime(-15);
    },
    goNext() {
      this.updateAudioTime(15);
    },
    updateAudioTime(delta) {
      const newTime = this.currentTime + delta;
      this.$refs["player-audio"].currentTime = newTime;
      this.currentTime = newTime;
    },
  },
};
</script>

<style scoped>
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.player-controllers {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
